import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getFocusGroupActivity = async (activityId) => {
    const { data } = await vlqrApi.get(`/FocusGroupActivities/${activityId}`)
        .catch((error) => {
            handleError(error);
        });

    return [data];
};

const getFocusGroupActivitiesByCrossSessionId = async (crossSessionId) => {
    const { data } = await vlqrApi.get(`/FocusGroupActivities/crossSession/${crossSessionId}`)
        .catch((error) => {
            handleError(error);
        });

    return data;
};

const useFocusGroupActivities = ({ activityId, crossSessionId }, options = {}) => {
    const queryKey = [crossSessionId
        ? 'focusGroupActivitiesByCrossSessionId'
        : 'focusGroupActivity'];
    const queryKeyValue = crossSessionId ?? activityId;

    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: [queryKey, queryKeyValue],
        queryFn: () => crossSessionId
            ? getFocusGroupActivitiesByCrossSessionId(crossSessionId)
            : getFocusGroupActivity(activityId),
        ...options
    });

    return { data, refetch, isLoading, isError };
};

export default useFocusGroupActivities;
